export const MultiValueConstants = {
  RowIdAlias: 'multiValueRowId'
};
